module.exports = __webpack_public_path__ + "img/Foto_FachfrauKundendialog-5317_2019.12953ea7.jpg";